<template>
    <div id="map">
        <l-map 
            :zoom="10" 
            :center="center" 
            :options="{zoomControl: false}"
            @mousemove="Get_Coordenates"
        >
            <l-tile-layer :url="url" />

            <l-geo-json 
                :geojson="geojson" 
                :options-style="styleMap" 
            />

            <!-- Muestra las coordenadas cuando el mouse pasa sobre el mapa -->

            <l-control position="bottomleft">
                <span id="coordinates">
                    {{ currentCoordinates.lat }} , {{ currentCoordinates.lng }}
                </span>
            </l-control>

            <!-- --- -->

            <l-control-zoom position="bottomleft" />

            <l-control-scale 
                position="bottomleft"
                :metric="true"
                :imperial="true"
            />

            <search-station 
                :hydrometereological-stations="hydrometereologicalStations" 
                :airquality-stations="airqualityStations"
                :accelerographic-stations="accelerographicStations" 
                :phreatrimetic-stations="phreatrimeticStations"
                :non-telemetric-metereological-stations="nonTelemetricMeteorologicalStations"
            />

            <l-layer-group :key="newKey">
                <l-marker
                    v-for="sta in hydrometereologicalStations" :key="sta.idStation"
                    :lat-lng="Get_Lat_Lng(sta.latitude,sta.longitude)"
                    @click="Commit_Station_To_Store(sta.idStation,0)"
                    :visible="markersHidro"
                >
                    <l-tooltip>{{ sta.name }}</l-tooltip>

                    <l-icon>
                        <img :src="Update_Icon(sta.idStation)">
                    </l-icon>
                </l-marker>

                <l-marker
                    v-for="sta in nonTelemetricMeteorologicalStations" :key="sta.idStation"
                    :lat-lng="Get_Lat_Lng(sta.latitude,sta.longitude)"
                    @click="Commit_Station_To_Store(sta.idStation,0)"
                    :visible="markersHidro"
                >
                    <l-tooltip>{{ sta.name }}</l-tooltip>

                    <l-icon>
                        <img src="@/assets/icons/comunitarias.svg">
                    </l-icon>
                </l-marker>

                <l-marker
                    v-for="sta in accelerographicStations" :key="sta.idStation"
                    :lat-lng="Get_Lat_Lng(sta.latitude,sta.longitude)"
                    @click="Commit_Station_To_Store(sta.idStation,1)"
                    :visible="markersAcele"
                >
                    <l-tooltip>{{ sta.name }}</l-tooltip>

                    <l-icon>
                        <img src="@/assets/icons/acelerografica.svg">
                    </l-icon>
                </l-marker>

                <l-marker
                    v-for="sta in phreatrimeticStations" :key="sta.idStation"
                    :lat-lng="Get_Lat_Lng(sta.latitude,sta.longitude)"
                    @click="Commit_Station_To_Store(sta.idStation,2)"

                    :visible="markersPhrea"
                >
                    <l-tooltip>{{ sta.name }}</l-tooltip>

                    <l-icon>
                        <img src="@/assets/icons/aguaSubterranea.svg">
                    </l-icon>
                </l-marker>

                <l-marker
                    v-for="sta in airqualityStations" :key="sta.idStation"
                    :lat-lng="Get_Lat_Lng(sta.latitude,sta.longitude)"
                    @click="Commit_Station_To_Store(sta.idStation,3)"
                    :visible="markersAirq"
                >
                    <l-tooltip>{{ sta.name }}</l-tooltip>

                    <l-icon>
                        <img src="@/assets/icons/calidad_aire.svg">
                    </l-icon>
                </l-marker>
            </l-layer-group>
        </l-map>
    </div>
</template>

<script>

    import axios from 'axios';
    import query from '@/services/links_apis.js';
    import caldasmap from './CaldasMun.json';
    import {latLng} from 'leaflet';
    import {mapActions, mapState, mapMutations} from 'vuex';
    import SearchStation from '@/components/SearchStation/SearchStation.vue';
    import {LMap,
            LTileLayer,
            LMarker,
            LControlScale,
            LGeoJson,
            LIcon,
            LTooltip,
            LLayerGroup,
            LControlZoom,
            LControl
            } from 'vue2-leaflet';

    export default {
        name: "LeafletMap",

        components: {
            LMap,
            LTileLayer,
            LMarker,
            LControlScale,
            LGeoJson,
            LIcon,
            LTooltip,
            LLayerGroup,
            LControlZoom,
            LControl,
            SearchStation
        },

        data(){
            return {
                center: latLng(5.29, -75.2),
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                geojson: caldasmap,
                styleMap:{
                    weight: 2,
                    color: '#6b6b6b',
                    opacity: 1,
                    fillColor: '#919191',
                    fillOpacity: 0.2
                },
                dataWebsocket: [],
                currentCoordinates: {lat:'',lng:''}
            }
        },

        computed:{
            ...mapState('stations',['hydrometereologicalStations','nonTelemetricMeteorologicalStations','accelerographicStations','phreatrimeticStations','airqualityStations']),

            ...mapState('markers',['markersHidro','markersAcele','markersPhrea','markersAirq','newKey']),

            ...mapState('station_id',['infoStation'])
        },

        methods: {
            ...mapActions('station_id',['Get_Station_Id']),

            ...mapMutations('station_id',['Change_State_Loading']),

            Get_Websocket(){
                window.setTimeout(() => axios.get(query.broadcast_websocket),(1000 * 2));
            },

            Commit_Station_To_Store(id,type){
                let inStore = false;
                this.infoStation.forEach(function(stations){
                    if(stations[0].idStation == id){
                        inStore = true;
                    }
                });
                if(!inStore){
                    this.Change_State_Loading(type);
                    this.Get_Station_Id(id);
                }
            },

            latitude(lat){
                let latitude = Math.abs(parseFloat(lat));
                let degrees = Math.floor(latitude * 1);
                let minutes = Math.floor((latitude - degrees)*60);
                let seconds = ((((latitude - degrees) * 60) - minutes) * 60);

                if(lat > 0){
                    return degrees + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'N';
                }else{
                    return degrees + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'S';
                }
            },

            longitude(lng){
                let longitude = Math.abs(parseFloat(lng));
                let degrees = Math.floor(longitude * 1);
                let minutes = Math.floor((longitude - degrees)*60);
                let seconds = ((((longitude - degrees) * 60) - minutes) * 60);

                if(lng > 0){
                    return degrees + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'E';
                }else{
                    return degrees + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'W';
                }
            },

            Get_Coordenates(event) {
                this.currentCoordinates.lat = this.latitude(event.latlng.lat);
                this.currentCoordinates.lng = this.longitude(event.latlng.lng);
            },

            Get_Lat_Lng(latitud,longitud){
                return latLng(latitud,longitud);
            },

            Update_Icon(id){
                let encontrado = false;
                for(var i in this.dataWebsocket){
                    for(var j in this.dataWebsocket[i]){
                        if(j == id){
                            encontrado = true;
                            if(this.dataWebsocket[i][j].length == 0){
                                return require('@/assets/icons/sinConexion.svg');
                            }else{
                                let fallidos = 0;
                                for(var k in this.dataWebsocket[i][j]){
                                    if(this.dataWebsocket[i][j][k].precipitation == null || this.dataWebsocket[i][j][k].temperature == null){
                                        fallidos ++;
                                    }
                                }
                                if(fallidos > 0){
                                    if(fallidos == 4){
                                        return require('@/assets/icons/desconectada.svg');
                                    }else{
                                        return require('@/assets/icons/desconectadaParcial.svg');
                                    }
                                }else{
                                    let k = this.dataWebsocket[i][j].length - 1;
                                    if(this.dataWebsocket[i][j][k].time > '06:00:00' && this.dataWebsocket[i][j][k].time <= '18:00:00'){
                                        if(this.dataWebsocket[i][j][k].precipitation == 0){
                                            if(this.dataWebsocket[i][j][k].temperature > 24){
                                                return require('@/assets/icons/despejado.svg');
                                            }else if(this.dataWebsocket[i][j][k].temperature > 21 && this.dataWebsocket[i][j][k].temperature <= 24){
                                                return require('@/assets/icons/nubladoParcial.svg');
                                            }else if(this.dataWebsocket[i][j][k].temperature <= 21){
                                                return require('@/assets/icons/nublado.svg');
                                            }
                                        }else{
                                            if(this.dataWebsocket[i][j][k].temperature <= 21){
                                                return require('@/assets/icons/lluvia.svg');
                                            }else{
                                                return require('@/assets/icons/nublado.svg');
                                            }
                                        }
                                    }else{
                                        if(this.dataWebsocket[i][j][k].precipitation == 0){
                                            return require('@/assets/icons/nubladoNoche.svg');
                                        }else{
                                            return require('@/assets/icons/lluviaNoche.svg');
                                        }
                                    }
                                }
                            }
                        }
                        break;
                    }
                }
                if(encontrado == false){
                    return require('@/assets/icons/sinConexion.svg');
                }
            }
        },

        created(){
            window.Echo.channel('channelFiveMinutes')
            .listen('GeoPortal.EveryFiveMinutes',(result) => {
                this.dataWebsocket = result;
            });
        },

        mounted(){
            this.Get_Websocket();
        }
    };
</script>

<style scoped lang="scss">

#map{
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 0;
}

#coordinates{
    background-color: $bg-light-color-transparent;
    font-weight: bold;
    padding: 0.2em;
    font-size: 1.2em;
}

img{
    border-radius: 1rem;
    box-shadow: .05rem .1rem .1rem rgb(27, 27, 27);
    cursor: pointer !important;
    margin-left: -7px;
    margin-top: -9px;
    width: 2.2em;
}

@media (min-width: 1500px) {
    img {
        margin-top: -9px;
        margin-left: -9px;
        width: 2.5em;
    }
}

@media (max-width: 600px) {
    #coordinates {
        font-size: .9em;
    }
}
</style>
